import { render, staticRenderFns } from "./CafeNotice.vue?vue&type=template&id=78836f82"
import script from "./CafeNotice.vue?vue&type=script&lang=js"
export * from "./CafeNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports